/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { forwardRef, type ReactNode, type Ref } from 'react';

import { jsx } from '@compiled/react';

import { cssMap, type StrictXCSSProp } from '@atlaskit/css';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	root: {
		listStyleType: 'none',
		margin: token('space.0'),
	},
});

type ListItemProps = {
	children: ReactNode;
	xcss?: StrictXCSSProp<'display', never>;
};

function _ListItem({ children, xcss }: ListItemProps, ref: Ref<HTMLDivElement>) {
	return (
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
		<div role="listitem" css={styles.root} ref={ref} className={xcss}>
			{children}
		</div>
	);
}

/**
 * __List item__
 *
 * A [list item](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/li) with visual styles removed.
 */
export const ListItem = forwardRef<HTMLDivElement, ListItemProps>(_ListItem);
